<template>
  <div>
    <main-header :siteTitle="siteTitle" :siteURL="siteURL">
      <ul slot="navlist">
        <!-- <li class="site-logo">
          <img src="@/assets/img/lose-pic1.png" alt="Site Logo" class="logo" />
          <span>{{ siteTitle }}</span>
        </li> -->
        <!-- Home -->
        <li :key="0">
          <router-link
            :to="siteNav[0].route"
            :class="{ active: activeState[0] }"
          >
            {{ siteNav[0].label }}
          </router-link>
        </li>
        <li v-for="(item, index) in siteNav.slice(1, 3)" :key="index + 1">
          <el-dropdown
            class="nav-dropdown"
            :hide-timeout="350"
            @visible-change="itemSearch = ''"
          >
            <a :class="{ active: activeState[index + 1] }">
              {{ item.label }}
              <i class="el-icon-arrow-down"></i>
            </a>
            <el-dropdown-menu
              slot="dropdown"
              :class="['nav-dropdown-menu', getDropdownClass(index)]" 
              v-if="navList.length > 0"
            >
              <el-input
                v-model="itemSearch"
                placeholder="Search..."
                style="width: 95%; margin-left: 5px"
                clearable
                v-if="navList[index].length > 20"
              ></el-input>
              <!-- <el-dropdown-item divided v-if="index === 0"></el-dropdown-item> -->
              <el-divider v-if="index === 0"
                ><span class="divider-text">Common</span></el-divider
              >
              <div v-if="index === 0">
                <li
                  v-for="(navItem, navIndex) in commonList"
                  :key="navIndex"
                  class="nav-dropdown-item"
                >
                  <router-link :to="navItem.route">
                    {{ navItem.label }}
                  </router-link>
                </li>
              </div>
              <el-divider v-if="index === 0"
                ><span class="divider-text">All</span></el-divider
              >
              <li
                v-for="(navItem, navIndex) in navList[index].filter((item) =>
                  item.label.toLowerCase().includes(itemSearch.replace(/_/g, ' ').toLowerCase())
                )"
                :key="navIndex + commonList.length"
                class="nav-dropdown-item"
              >
                <router-link :to="navItem.route">
                  {{ navItem.label }}
                </router-link>
              </li>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li v-for="(item, index) in siteNav.slice(3, 5)" :key="index + 3">
          <router-link
            :to="item.route"
            :class="{ active: activeState[index + 3] }"
          >
            {{ item.label }}
          </router-link>
        </li>
        <li v-if="siteNav[5]">
          <router-link
            :to="siteNav[5].route"
            :class="{ active: activeState[5] }"
          >
            <button class="btn-hover color-5">{{ siteNav[5].label }}</button>
          </router-link>
        </li>
      </ul>
    </main-header>
  </div>
</template>

<script>
import MainHeader from "@/components/header/MainHeader.vue";
import { getNavList } from "@/api/api";

export default {
  components: { MainHeader },
  data() {
    return {
      activeState: [0, 0, 0, 0, 0, 0, 0],
      siteTitle: "T2T-Hub",
      siteURL: "/t2thub/home",
      siteNav: [
        { route: "/home", label: "Home" },
        { route: "/genome", label: "Genome" },
        { route: "/tools", label: "Tools" },
        { route: "/download", label: "Download" },
        { route: "/help", label: "Help" },
        // { route: '/pangenome', label: 'PanGenome' },
        { route: "/upload", label: "Analysis" },
      ],
      navList: [],
      commonList: [
        { route: "/genome/Arabidopsis_thaliana_Col-CEN", label: "🍀 Arabidopsis thaliana CEN" },
        { route: "/genome/Oryza_sativa_NIP", label: "🌾 Oryza sativa NIP" },
        { route: "/genome/Zea_mays_Mo17", label: "🌽 Zea mays Mo17" },
        // { route: "/genome/Glycine_max_Wm82", label: "Glycine max Wm82" },
        // { route: "/genome/Setaria_italica_Yugu1", label: "Setaria italica Yugu1" },
        // { route: "/genome/Physcomitrium_patens", label: "Physcomitrium patens" },
        { route: "/genome/Homo_sapiens_CHM13", label: "🧍‍♂️ Homo sapiens CHM13" },
        { route: "/genome/Mus_musculus", label: "🐀 Mus musculus mhaESC" },
        { route: "/genome/Triticum_aestivum_CS-IAAS", label: "🥖 Triticum aestivum CS-IAAS" },
      ],
      itemSearch: "",
    };
  },
  watch: {
    $route: function () {
      const rootPath = this.$route.path.split("/")[1];
      const site = this.siteNav.map((item) => item.route.slice(1));
      this.activeState = [0, 0, 0, 0, 0];
      this.activeState[site.indexOf(rootPath)] = 1;
    },
  },
  methods: {
    getDropdownClass(index) {
      return index === 0 ? "nav-dropdown-menu--genome" : "nav-dropdown-menu";
    },
  },
  created() {
    getNavList().then((response) => {
      const genomeNav = response.data.genome.map((item) => {
        if (
          item === "adiantum_capillus_veneris" ||
          item === "bryhnia_novae_angliae" ||
          item === "taraxacum_kok_saghyz" ||
          item === "echinochloa_crus_galli"
        ) {
          let first = item.indexOf("_");
          const str = item;
          item = item.replace("_", " ");
          let second = item.indexOf("_", first + 1);
          item = item.substring(0, second) + "-" + item.substring(second + 1);
          let result = item.charAt(0).toUpperCase() + item.slice(1);
          return { route: "/genome/" + str, label: result };
        } else {
          // console.log(item.replace(/_/g, ' '))
          return { route: "/genome/" + item, label: item.replace(/_/g, " ") };
        }
      });
      const toolsNav = response.data.tools.map((item) => {
        return { route: "/tools/" + item.route, label: item.label };
      });
      this.navList = [genomeNav, toolsNav];
    });
  },
};
</script>

<style lang="scss">
.site-logo {
  display: flex;
  align-items: center;
  margin-right: 20px; /* 调整 logo 与标题的间距 */
}

.site-logo .logo {
  height: 40px; /* 根据需求调整 logo 大小 */
  width: auto;
  margin-right: 10px; /* 让 logo 与标题分开一些 */
}

.site-logo span {
  font-size: 18px; /* 调整标题的字体大小 */
  font-weight: bold; /* 根据需求选择字体样式 */
}

.divider-text {
  font-weight: bold;
  font-size: 17px;
  color: #2ca25f;
}

a {
  text-decoration: none !important;
}

.nav-dropdown {
  font-size: 16px !important;
  color: #505050 !important;
}

.nav-dropdown-menu--genome {
  transform: translateY(16px) !important;
  padding: 0;
  max-height: 700px;
  overflow-y: auto;
  min-width: 300px;
}

.nav-dropdown-menu {
  transform: translateY(16px) !important;
  padding: 0;
  max-height: 700px;
  overflow-y: auto;
}

.nav-dropdown-item {
  list-style-type: none;

  a {
    height: 36px;
    line-height: 36px;
    font-weight: 600;
    text-decoration: none;
    text-align: center;
    display: block;
    color: #505050;
    padding: 0 8px;

    &:hover {
      color: #505050;
      background-color: #2ca25f33;
    }

    &.active {
      color: #2ca25f;
    }
  }
}

.btn-hover {
  // width: 200px;
  // font-size: 20px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  // margin: 10px;
  // width: 30%; /* 与搜索框保持一致 */
  // height: 3.6rem; /* 高度与搜索框保持一致 */
  text-align: center;
  border: none;
  background-size: 300% 100%;

  border-radius: 50px;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btn-hover:hover {
  background-position: 100% 0;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btn-hover:focus {
  outline: none;
}

.btn-hover.color-1 {
  background-image: linear-gradient(
    to right,
    #25aae1,
    #40e495,
    #30dd8a,
    #2bb673
  );
  box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);
}
.btn-hover.color-2 {
  background-image: linear-gradient(
    to right,
    #f5ce62,
    #e43603,
    #fa7199,
    #e85a19
  );
  box-shadow: 0 4px 15px 0 rgba(229, 66, 10, 0.75);
}

.btn-hover.color-3 {
  background-image: linear-gradient(
    to right,
    #667eea,
    #764ba2,
    #6b8dd6,
    #8e37d7
  );
  box-shadow: 0 4px 15px 0 rgba(116, 79, 168, 0.75);
}

.btn-hover.color-4 {
  background-image: linear-gradient(
    to right,
    #fc6076,
    #ff9a44,
    #ef9d43,
    #e75516
  );
  box-shadow: 0 4px 15px 0 rgba(252, 104, 110, 0.75);
}

.btn-hover.color-5 {
  background-image: linear-gradient(
    to right,
    #0ba360,
    #3cba92,
    #30dd8a,
    #2bb673
  );
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
}

.btn-hover.color-6 {
  background-image: linear-gradient(
    to right,
    #009245,
    #fcee21,
    #00a8c5,
    #d9e021
  );
  box-shadow: 0 4px 15px 0 rgba(83, 176, 57, 0.75);
}

.btn-hover.color-7 {
  background-image: linear-gradient(
    to right,
    #6253e1,
    #852d91,
    #a3a1ff,
    #f24645
  );
  box-shadow: 0 4px 15px 0 rgba(126, 52, 161, 0.75);
}

.btn-hover.color-8 {
  background-image: linear-gradient(
    to right,
    #29323c,
    #485563,
    #2b5876,
    #4e4376
  );
  box-shadow: 0 4px 15px 0 rgba(45, 54, 65, 0.75);
}

.btn-hover.color-9 {
  background-image: linear-gradient(
    to right,
    #25aae1,
    #4481eb,
    #04befe,
    #3f86ed
  );
  box-shadow: 0 4px 15px 0 rgba(65, 132, 234, 0.75);
}

.btn-hover.color-10 {
  background-image: linear-gradient(
    to right,
    #ed6ea0,
    #ec8c69,
    #f7186a,
    #fbb03b
  );
  box-shadow: 0 4px 15px 0 rgba(236, 116, 149, 0.75);
}

.btn-hover.color-11 {
  background-image: linear-gradient(
    to right,
    #eb3941,
    #f15e64,
    #e14e53,
    #e2373f
  );
  box-shadow: 0 5px 15px rgba(242, 97, 103, 0.4);
}
</style>